<template>
  <!-- eslint-disable vue/no-mutating-props -- account is a nested reactive object from parent form state, bound via v-model -->
  <fieldset>
    <div class="group">
      <div class="field">
        <label :for="fieldId('account', index, 'relation')">{{ $t('relation to main tenant') }}</label>
        <div>
          <select :id="fieldId('account', index, 'relation')" v-model="account.relation.option">
            <option v-for="option in tenantRelations" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
          <v-form-error :error="errors[`accounts.${index}.relation.option`]" />
        </div>
      </div>

      <div v-if="account.relation.option === 'other'" class="field">
        <label :for="fieldId('account', index, 'relation-other')">{{ $t('relation to main tenant') }}</label>
        <div>
          <input :id="fieldId('account', index, 'relation-other')" type="text" v-model="account.relation.other" />
          <v-form-error :error="errors[`accounts.${index}.relation.other`]" />
        </div>
      </div>
      <div v-else class="field"></div>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import { useRegistrationContext } from '/@front:shared/composables/useRegistrationContext'
import type { Account } from '/@front:shared/registration'
import { fieldId } from '/@front:shared/utils'

defineProps<{
  account: Account
  index: number
  errors: Record<string, string>
}>()

const { tenantRelations } = useRegistrationContext()
</script>
